export default "__VITE_ASSET__CCq1VVVA__"